// react
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

// components
import Checkbox from "../../../components/Inputs/Checkbox";

// actions
import { changePermission } from "../actions";

// selectors
import { getPermissions } from "../selectors";

export class PermissionsScreen extends React.Component {
	static propTypes = {
		changePermission: PropTypes.func.isRequired,
		isActive: PropTypes.bool.isRequired,
		permissionGoals: PropTypes.bool.isRequired,
	};

	static defaultProps = {};

	handlePermissionChange = (name, value) => {
		this.props.changePermission(name, value);
	};

	render() {
		// Revert this and the commented out permissions below when
		// we actually add those permissions
		const { isActive, permissionGoals } = this.props;
		const permissionReviews = true;

		if (!isActive) {
			return <div />;
		}

		return (
			<section className="permissions-screen" style={{}}>
				<div className="permission-item">
					<Checkbox
						value={permissionGoals}
						onChange={(value) => {
							this.handlePermissionChange("group-goals", value);
						}}
					/>
					<div className="permission-label">Allow group admins to access group member goals</div>
				</div>

				<div className="permission-item">
					<Checkbox
						value={permissionReviews}
						onChange={(value) => {
							this.handlePermissionChange("group-reviews", value);
						}}
						disabled={true}
					/>
					<div className="permission-label">Allow group admins to access group member reviews</div>
				</div>
			</section>
		);
	}
}

export const mapStateToProps = (state) => {
	const permissions = getPermissions(state);

	return {
		permissionGoals: permissions.get("group-goals"),
		permissionReviews: permissions.get("group-reviews"),
		permissionFeedback: permissions.get("group-feedback"),
	};
};

const mapDispatchToProps = (dispatch) => ({
	changePermission: (name, value) => dispatch(changePermission(name, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PermissionsScreen);
